@if (!user.isPremium) {
  <gl-icon
    [name]="'pro'"
    (click)="openProInfoModal($event)"
  ></gl-icon>
}
